var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.goDingyue}},[_vm._v("立即订阅")]),_c('div',{ref:"dingyue_box_ref",staticClass:"dingyue_box"},[_vm._v(" 立即订阅内容 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }